module.exports = __webpack_public_path__ + "static/media/IMG20240514101504.06f02eb3.jpg";